<div class="skeleton">
    <div class="connections">
        <div class="bone connectionCard"></div>
        <div class="bone connectionCard"></div>
        <div class="bone connectionCard"></div>
    </div>

    <div class="bone connectionAddButton"></div>
</div>